export default __webpack_public_path__ + "static/media/icon-1.1b6e6611.svg";